<template lang="">
  <el-drawer
    :visible="getAfterSalesDialog.visible"
    @close="handleClose"
    title="申请售后"
    class="order-drawer-container"
    :size="isMobile.matches ? '100%' : 790"
  >
    <div class="drawer-body">
      <el-form
        ref="drawerFrom"
        :model="drawerFrom"
        label-position="top"
        label-width="120px"
        :rules="drawerFromRules"
        :inline="true"
      >
        <el-form-item
          label="您遇到的问题:"
          prop="problem"
          style="width: 320px; text-align: left;"
        >
          <el-select
            @change="problemChange"
            v-model="drawerFrom.problem"
            placeholder="全部"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in problemOps"
              :key="index"
              :label="item.issueName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="问题类型:"
          prop="problemType"
          style="width: 320px; text-align: left"
        >
          <el-select
            v-model="drawerFrom.problemType"
            placeholder="全部"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in problemTypeOps"
              :key="index"
              :label="item.questionTypeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="isNumber"
          label="异常小鼠只数:"
          style="width: 320px; text-align: left"
          prop="num"
        >
          <el-input
            v-model="drawerFrom.num"
            style="width: 100%"
            placeholder="请输入异常小鼠只数"
          ></el-input
        ></el-form-item>
        <el-form-item
          label="希望的解决方案:"
          prop="programme"
          style="width: 320px; text-align: left"
        >
          <el-select
            v-model="drawerFrom.programme"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in programmeOps"
              :key="index"
              :label="item.solutionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述:" prop="message" style="width: 654px; text-align: left">
          <el-input
            style="width: 100%"
            v-model="drawerFrom.message"
            type="textarea"
            :rows="5"
            placeholder="内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btns">
        <el-button type="primary" class="confirm" @click="conShopAdd">提交</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import userApi from "@/api/user.js";

export default {
  name: "apply-service",

  computed: {
    ...mapGetters("order", ["getAfterSalesDialog"]),
  },

  data() {
    return {
      isNumber: false,
      uploadHeaders: { Authorization: localStorage.getItem("token") },

      fileMd5: {
        fileMd5: "",
      },

      fileList: [],

      problemTypeOps: [],
      programmeOps: [],
      problemOps: [],
      drawerFromRules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],

        url: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        problem: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        problemType: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        programme: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        message: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
      },
      drawerFrom: {
        url: "",
        problem: "",
        problemType: "",
        num: "",
        programme: "",
        message: "",
      },

      isMobile: window.matchMedia('(max-width: 1023px)')
    };
  },

  computed: {
    ...mapGetters("order", ["getAfterSalesDialog"]),
  },

  methods: {
    ...mapActions("order", ["requestAfterSales"]),
    ...mapMutations("order", ["setAfterSalesDialog"]),

    handleClose() {
      this.setAfterSalesDialog({
        visible: false,
      });

      if (this.getAfterSalesDialog.closeAfter) {
        this.getAfterSalesDialog.closeAfter();
      }
    },

    problemChange(e) {
      let arr = this.problemOps.filter((el) => {
        return el.id == e;
      })[0];

      this.drawerFrom.problemType = "";
      this.drawerFrom.programme = "";

      if (arr.number == 1) {
        this.isNumber = true;
      } else {
        this.isNumber = false;
      }
      userApi
        .questionType({
          channel: "pc",
          issueId: arr.id,
          issueName: arr.issueName,
        })
        .then((ress) => {
          this.problemTypeOps = ress.data;
        });
      userApi
        .solution({
          channel: "pc",
          issueId: arr.id,
          issueName: arr.issueName,
        })
        .then((red) => {
          this.programmeOps = red.data;
        });
    },

    async conShopAdd() {
      const result = await this.$refs.drawerFrom.validate();
      if (!result) {
        return;
      }

      let params = {
        afterSalesOrderDetailDTO: {
          channel: "pc",
          issueId: this.drawerFrom.problem,
          issueName: this.problemOps.filter((el) => {
            return el.id == this.drawerFrom.problem;
          })[0].issueName,
          questionDescription: this.drawerFrom.message,
          questionTypeName: this.problemTypeOps.filter((el) => {
            return el.id == this.drawerFrom.problemType;
          })[0].questionTypeName,
          questionTypeId: this.drawerFrom.problemType,
          solutionId: this.drawerFrom.programme, //	解决方案id
          solutionName: this.drawerFrom.programme, //solutionName

          number: drawerFrom.num, //异常小只数
        },
        channel: "pc",
        expectedDeliveryDate: this.afterRow.expectedDeliveryDate,
        id: 0,
        orderNumber: this.afterRow.orderNumber,
        productName: this.afterRow.productName,
        questionTypeName: this.problemTypeOps.filter((el) => {
          //问题类型名称
          return el.id == this.drawerFrom.problemType;
        })[0].questionTypeName,
        submitTime: this.afterRow.submitTime,
      };
      if (this.drawerFrom.url) {
        params.afterSalesOrderDetailDTO["annexUrl"] = this.drawerFrom.url;
      }
      console.log(params, "--params--");

      this.setAfterSalesDialog({
        params: {
          ...this.getAfterSalesDialog.params,
          ...params,
        },
      });

      const requestResult = await this.requestAfterSales();

      if (requestResult) {
        this.setAfterSalesDialog({
          visible: false,
        });
        if (this.getAfterSalesDialog.closeAfter) {
          this.getAfterSalesDialog.closeAfter();
        }
      }
    },

    getType() {
      userApi
        .addSales({
          channel: "pc",
        })
        .then((res) => {
          this.problemOps = res.data;
        });
    },
    onSuccess(e) {
      if (e.code == 200) {
        this.drawerFrom.url = e.data.accessPath;
      } else {
        this.$message.success(e.msg);
      }
    },
    fileChange(file) {
      var fileReader = new FileReader();
      var dataFile = file.raw;

      //获取文件二进制数据
      var Spark = new SparkMD5.ArrayBuffer();
      fileReader.readAsArrayBuffer(dataFile);
      //异步执行函

      fileReader.onload = (e) => {
        Spark.append(e.target.result);
        var md5 = Spark.end();
        this.fileMd5.fileMd5 = md5;
        this.$refs["frontImg"].submit();
      };
    },

    fileremove(ee) {
      this.drawerFrom.url = "";
    },
    fileupload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("文件大小不得超过5M");
      }
      return isLt2M;
    },
  },

  mounted() {
    console.log(
      "this.getAfterSalesDialog.visible",
      this.getAfterSalesDialog.visible
    );
    this.getType();
  },
};
</script>
<style lang="less" scoped>
.drawer-body {
  padding: 0 62px;
}
</style>



// WEBPACK FOOTER //
// src/components/ApplyService/index.vue